import React, { PropsWithChildren } from 'react';
import { DivProps } from '../../../../types/HtmlProps';
import { appendClassName } from '../../../../lib/bemUtils/classname';

type AccordionProps = {
  ref?: React.RefObject<HTMLDivElement | null>;
} & PropsWithChildren<DivProps>;

export function Accordion({ children, className, ref, ...divProps }: AccordionProps) {
  return (
    <div {...divProps} className={appendClassName(className, 'accordion')} ref={ref}>
      {children}
    </div>
  );
}
